import CryptoJS from "crypto-js";

export const hash = (text: string) => {
    const result = CryptoJS.MD5(text).toString();
    return result;
}

export const nonce = () => {
    return Math.random().toString(36).substring(2,9);
}